import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom, type AtomRenderProps} from '@packages/systems/wfdl';
import {
  TTypeConstructor,
  TTypeReference,
  TTypeApplication,
} from '@packages/systems/wfdl-ast';

const FormTextInput = Atom.createRender(
  ({attributes, classes, generateAttributes}: AtomRenderProps) => {
    const inputClasses = classes.push('w-input');
    return <input {...generateAttributes(attributes, inputClasses)} />;
  }
);

const config = Atom.create({
  displayName: 'Text Field',
  constraints: {
    ancestors: [
      {
        is: 'FormForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  dataType: TTypeApplication({
    con: TTypeConstructor(
      qualify(Plugins.name('Form'), typeName('FormTextInput'))
    ),
    arg: TTypeReference('extraAtomFields'),
  }),
  showEmpty: false,
  render: FormTextInput,
});

export default config;
